// Announcement strip shown between the Leaderboard and Rounds.
// Update it each month, or set title to "" to hide the strip entirely.
// Emoji are real Unicode characters — swap them freely.
//   title  = the heading line
//   lines  = short text lines shown under the title (leave [] for none)
//   photos = optional photos, e.g. { src: "/images/bash.jpg", alt: "..." }
//   caption = optional one-liner under the photos
export const ANNOUNCEMENT = {
  title: "🎂 OCTOBER BIRTHDAY 🎉",
  lines: [
    "Only one birthday this month, for a very special man.",
    "The one and only Mr. Cruz.",
    "Cake day this Saturday. 🥳",
  ],
  photos: [],
  caption: "",
};
